import React, { useEffect } from "react";
import Quiz1 from "../components/Quiz1";
import Navbar from "../components/Navbar";

const QuizPage = () => {

  return (
    <div className="min-h-screen bg-[#EDE3DD] p-2 md:p-8">
      <Navbar navItems={[]} />
      <Quiz1 />
    </div>
  );
};

export default QuizPage;
